module.exports = __webpack_public_path__ + "static/img/zgkjfsdy.1217a57.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/zgkjfsdy.png
// module id = nAdq
// module chunks = 0